import { t } from 'i18next';
import ServiceNowIcon from '../../../../../assets/images/service-now-icon.svg';
import { ExportType } from '../../../../../integrations/exports/models/BatchExport';
import { BatchExportSelector, BatchExportSelectorProps } from './BatchExportSelector';

type ServiceNowSelectorProps = Omit<BatchExportSelectorProps, 'description' | 'disabledReason' | 'onCancel'> & {
  selectedInstancesCount: number;
  onCancel: (exportType: ExportType) => Promise<void>;
};

export const ServiceNowSelector = ({ selected, disabled, loading, selectedInstancesCount, onSelected, exportJob, onCancel }: ServiceNowSelectorProps) => {
  return (
    <BatchExportSelector
      title={t('serviceNow')}
      description={t(selectedInstancesCount > 0 ? 'exportFormats.serviceNow.multiSelect' : 'exportFormats.serviceNow.report')}
      icon={<ServiceNowIcon aria-hidden="true" width="40" height="40" />}
      selected={selected}
      loading={loading}
      disabled={disabled}
      disabledReason={t('integrationList.serviceNow.notConfiguredForYourOrganization')}
      onSelected={onSelected}
      exportJob={exportJob}
      onCancel={() => onCancel(ExportType.SERVICE_NOW)}
    />
  );
};
